/**
 * Brazilian Portuguese (pt-BR) mappings for MobileTopBanner
 */

export const mobileTopBannerPtBR = {
  // App name
  "PickStar": "PickStar",
  "PickStar AI": "PickStar AI", // Keep for backward compatibility
  "PS": "PS",
  
  // Button labels and aria-labels
  "Menu": "Menu",
  "AI Toolkit": "Kit de IA",
  "Game Explorer": "Explorador de Jogos",
  "Pick Slip": "Bilhete",
  "New Chat": "Nova Conversa",
  "More options": "Mais opções",
  
  // Game banner (if any)
  "Make Pick": "Fazer Aposta",
  "Close banner": "Fechar banner"
};